<template>
  <survey-management />
</template>

<script>
import SurveyManagement from "@/components/surveyManagement/SurveyManagement.vue";
export default {
  name: "AdminSurveyResultManagement",
  components: {
    "survey-management": SurveyManagement,
  },
  data() {
    return {};
  },
};
</script>
